import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import styles from "./Steps.module.css";
import StatusBadge from "../StatusBadge/StatusBadge";
import Cookies from "js-cookie";
import axios from "axios";

const StepsTable = ({ serverIP }) => {
    const [stepsData, setStepsData] = useState({});
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchTeamData = async () => {
        try {
            setIsLoading(true);        
            const teamId = Cookies.get("team_id");
            if (!teamId) {
                throw new Error("Team ID отсутствует в куках.");
            }

            const response = await axios.get(`${serverIP}/v1/team`, {
                params: { team_id: teamId },
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const teamData = response.data;

            if (!teamData || !teamData.workers) {
                throw new Error("Данные команды пустые или имеют неправильную структуру.");
            }

            const formattedData = {};

            teamData.workers.forEach((worker) => {
                worker.step_history.forEach((step) => {
                    if (!formattedData[step.step]) {
                        formattedData[step.step] = {
                            name: step.step,
                            data: [],
                        };
                    }
                    formattedData[step.step].data.push({
                        name: worker.name,
                        status: step.status,
                        action: step.action,
                        involvement: step.score,
                    });
                });
            });

            const sortedData = Object.keys(formattedData)
                .sort((a, b) => parseInt(a.replace(/\D/g, ""), 10) - parseInt(b.replace(/\D/g, ""), 10))
                .reduce((acc, key) => {
                    acc[key] = formattedData[key];
                    return acc;
                }, {});

            setStepsData(sortedData);
        } catch (error) {
            console.error("Ошибка получения данных команды:", error.message);
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchTeamData();
    }, []);

    if (isLoading) {
        return <p>Загрузка данных...</p>;
    }

    if (error) {
        return <p>Ошибка: {error}</p>;
    }

    const steps = Object.keys(stepsData);
    const handleStepChange = (index) => {
        setCurrentStepIndex(index);
    };

    const stepsToDisplay = steps.filter((_, index) =>
        index === currentStepIndex 
    );

    return (
        <div className={styles.steps}>
            {/* Навигация по шагам */}
            <nav className={styles.nav}>
                {steps.map((_, index) => (
                    <span
                        key={index}
                        onClick={() => handleStepChange(index)}
                        style={{
                            cursor: "pointer",
                        }}
                        className={currentStepIndex === index ? styles.select : styles.normal}
                    >
                        Шаг {index + 1}
                    </span>
                ))}
            </nav>

            {/* Заголовок шага */}
            {stepsToDisplay.length > 0 && (
                <h2 className={styles.stepTitle}>
                    {stepsData[stepsToDisplay[0]]?.name}
                </h2>
            )}

            <div className={styles.container}>
                {stepsToDisplay.map((step) => (
                    <div key={step} className={styles.stepTable}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th className={styles.nameCell}>Сотрудники</th>
                                    <th>Текущий типаж</th>
                                    <th>Активность</th>
                                    <th>Баллы</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stepsData[step].data.map((row, index) => (
                                    <tr key={index}>
                                        <td className={styles.nameCell}>{row.name}</td>
                                        <td>
                                            <StatusBadge status={row.status} />
                                        </td>
                                        <td className={styles.actionCell}>{row.action}</td>
                                        <td style={{ width: 100 }}>{row.involvement}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>                                    
                                    <td style={{ padding: 0, fontWeight: 700, fontSize: 20 }}>
                                        {stepsData[step].data.reduce(
                                            (sum, row) => sum + (row.involvement || 0),
                                            0
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        </div>
    );
};

function Steps({ isAdmin, serverIP }) {
    return (
        <div className="App">
            <SideBar 
                blueStep={{ backgroundColor: "#0170ba", color: "#fff" }} 
                isAdmin={isAdmin}
            />
            <div style={{ marginTop: "40px" }}>
                <StepsTable serverIP={serverIP} />
            </div>
        </div>
    );
}

export default Steps;